import * as React from "react";
import classNames from "classnames";
import styles from "./icon.module.scss";

interface IconProps {
  name: string;
  className?: string;
  size?: string;
  iconComponent: React.SFC<React.SVGProps<SVGSVGElement>>;
}

const Icon: React.SFC<IconProps> = ({
  name,
  className,
  size,
  iconComponent,
  children,
  ...rest
}) => {
  const IconComponent = iconComponent;
  const fullClassName = classNames('icon', `icon__${name}`, className, size);
  return (
    <IconComponent
      aria-labelledby={`icon-${name}-title`}
      className={fullClassName}
      role="img"
      key={name}
      {...rest}
    />
  );
};

export default Icon;
